import { Observable } from 'rxjs';
import { ContactPerson } from './../../jurisdiction/jurisdiction.domain';
import { Injectable } from '@angular/core';
import { CommunicationService } from 'src/app/services/communication.service';

const ContactPersonRoute = 'contact-person';

@Injectable({
  providedIn: 'root',
})
export class ContactPersonService {
  constructor(private readonly communicationService: CommunicationService) {}

  public upsert(contactPerson: ContactPerson): Observable<ContactPerson> {
    return this.communicationService.postData('contact-person', contactPerson);
  }
}
